import { useState } from 'react'

// /qm and /qm/* inside the main app: hand over to the QM field app at /qm/ (S1 a, c).
// A real /qm/ load (qm.html) clears the marker. If the main app shows this route again within
// 10 s of the last redirect, /qm/ did not serve qm.html: show a message and do NOT reload.
const KEY = 'qm_weiche'
const WINDOW_MS = 10_000

let memo: { at: number; redirect: boolean } | null = null

function shouldRedirect(): boolean {
  // React StrictMode (dev) runs this twice in a row: the second call must give the same answer.
  if (memo && Date.now() - memo.at < 1000) return memo.redirect
  const redirect = decide()
  memo = { at: Date.now(), redirect }
  return redirect
}

function decide(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0)
    if (Date.now() - last < WINDOW_MS) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch { /* storage blocked: redirect once, nothing to compare */ }
  return true
}

export default function QmWeiche() {
  const [redirect] = useState(shouldRedirect)
  if (redirect) {
    location.replace('/qm/')
    return null
  }
  return (
    <p style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      Die QM-App konnte nicht geladen werden. Bitte mit Netz neu öffnen.
    </p>
  )
}
